const log = {
    invalid_type: '로그 종류가 유효하지 않아요.',
    invalid_time_window: '`end_time`은 `start_time` 이후여야 해요.',
};
export default Object.freeze(log);
